import type { VariantProps } from 'class-variance-authority'
import { cva } from 'class-variance-authority'
import { useCallback, useState } from 'react'
import type { BehaviorSubject } from 'rxjs'

const select = cva(
  'border border-gray-400 hover:border-gray-500 rounded-lg px-4 py-0.5 sm:py-1 mt-2 bg-font-contrast text-font-default focus:outline-primary outline-offset-2 outline-1 w-full',
  {
    variants: {}
  }
)

export interface ISelectOption {
  label: string
  value: string
  disabled?: boolean
}

export interface ISelectProps<T> extends VariantProps<typeof select> {
  onChange$: BehaviorSubject<T>
  options: ISelectOption[]
  initialValue: T
  isValid?: boolean
  disabled?: boolean
}

export const Select = <T extends string | number | readonly string[] | undefined>({
  options,
  onChange$,
  initialValue,
  isValid,
  disabled
}: ISelectProps<T>) => {
  //! State
  const [value, setValue] = useState<T>(initialValue)

  //! Callbacks
  const handleOnChange = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event: any) => {
      if (onChange$) onChange$.next(event.target.value)
      setValue(event.target.value)
    },
    [onChange$]
  )

  return (
    <select
      className={select({})}
      onChange={handleOnChange}
      value={value}
      color={isValid === true ? 'success' : isValid === false ? 'error' : 'primary'}
      disabled={disabled}
    >
      {options.map((child, index) => (
        <option value={child.value} key={`${index}_${child.value}`} disabled={child.disabled}>
          {child.label}
        </option>
      ))}
    </select>
  )
}
